"use client"

import { RequisitionsSchema } from "@/schemas/requisitions.schema"
import z from "zod"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table"
import RequisitionDeleteModal from "./RequisitionDeleteModal"

interface Props {
    requisitionsEntries: z.infer<typeof RequisitionsSchema>[],
    updateData: () => void,
}

export default function RequisitionsTable(props: Props){
    return (
        <div>
            {props.requisitionsEntries.length <= 0 && (
                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                    <p>No Requisition Entries available</p>
                </div>
            )}

            {props.requisitionsEntries.length > 0 && (
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>#</TableHead>
                            <TableHead>Domain Name</TableHead>
                            <TableHead>DomainID</TableHead>
                            <TableHead>MainFolder</TableHead>
                            <TableHead>SubFolder</TableHead>
                            <TableHead>Delete</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {props.requisitionsEntries?.map((entry, _index) => (
                            <TableRow key={entry.ID}>
                                <TableCell>{entry.ID}</TableCell>
                                <TableCell>{entry.Name}</TableCell>
                                <TableCell>{entry.DomainID}</TableCell>
                                <TableCell>{entry.MainFolder}</TableCell>
                                <TableCell>{entry.SubFolder}</TableCell>
                                <TableCell><RequisitionDeleteModal entry={entry} updateData={props.updateData}/></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </div>
    )
}